import React from 'react';
import { Button, Icon, Popup } from 'semantic-ui-react';
import MarkdownRender from '../text-editors/MarkdownRender';

const MarkdownLinksCellPopup = ({ links, theme }) => (
  <Popup
    position="right center"
    className={`aridhia-theme-${theme}`}
    hoverable
    wide
    content={(<MarkdownRender value={links.join('\n')} />)}
    trigger={(
      <Button icon size="mini" className="aridhia-markdown-links-cell--hover">
        <Icon name="ellipsis horizontal" />
      </Button>
                )}
  />
);

export default MarkdownLinksCellPopup;
